import { render, staticRenderFns } from "./Science.vue?vue&type=template&id=4971b2ee&scoped=true&"
import script from "./Science.vue?vue&type=script&lang=js&"
export * from "./Science.vue?vue&type=script&lang=js&"
import style0 from "./Science.vue?vue&type=style&index=0&id=4971b2ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971b2ee",
  null
  
)

export default component.exports